module.exports = __webpack_public_path__ + "assets/Gamma.0e9794d6b477c397ce37a8fec7b115af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Gamma.png
// module id = 834
// module chunks = 0